var map = {
	"./0.png": 7547,
	"./1.png": 292722,
	"./2.png": 623689,
	"./3.png": 745568,
	"./4.png": 696895,
	"./5.png": 283606,
	"./6.png": 97581,
	"./7.png": 843684,
	"./8.png": 103907,
	"./9.png": 339802,
	"./dian.png": 558047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 542298;